import React from "react";
import { TableRow } from "./TableRow";
import { NoRows } from "../../../../../layout/Table/NoRows";

function TableBody(props) {
  const renderRows = () => {
    const { groups } = props;

    if (!Array.isArray(groups) || groups.length === 0) {
      return <NoRows colSpan="5" />;
    }

    return groups.map(renderRow);
  };

  const renderRow = (group, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        key={index}
        group={group}
        actionCallback={actionCallback}
        index={index}
      />
    );
  };

  return <tbody>{renderRows()}</tbody>;
}

export { TableBody };
